import { actions as reducerActions } from "./reducers";
import * as actionsFile from "./thunks";

export const actions = {
    ...reducerActions,
    ...actionsFile
};

export * as selectors from "./selectors";
